



























import { Vue, Component } from 'vue-property-decorator';

import CustomerImportEmailSent from '@/components/icons/CustomerImportEmailSent.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    CustomerImportEmailSent,
    FilledButton,
    CloseModalIcon
  }
})
export default class Success extends Vue {
  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get customerImportV2() {
    return this.flags.includes('customer-import-v2');
  }

  handleClose() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Campaign sent!`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Close" button`
    });

    this.$emit('customer-import-event', { type: 'closeModal' });
  }

  handleSubmit() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Campaign sent!`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Check your campaign progress" button`
    });

    const customerImportPath = '/customer-import';

    if (window.location.pathname.includes(customerImportPath)) {
      this.$emit('customer-import-event', { type: 'closeModal' });

      return;
    }

    this.$router.push(customerImportPath);
  }
}
